/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPlanAccessDto
 */
export interface SubscriptionPlanAccessDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPlanAccessDto
     */
    allowedChatInterfaces: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPlanAccessDto
     */
    allowedMlsProviders: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPlanAccessDto
     */
    allowedStates: Array<string>;
}

/**
 * Check if a given object implements the SubscriptionPlanAccessDto interface.
 */
export function instanceOfSubscriptionPlanAccessDto(value: object): value is SubscriptionPlanAccessDto {
    if (!('allowedChatInterfaces' in value) || value['allowedChatInterfaces'] === undefined) return false;
    if (!('allowedMlsProviders' in value) || value['allowedMlsProviders'] === undefined) return false;
    if (!('allowedStates' in value) || value['allowedStates'] === undefined) return false;
    return true;
}

export function SubscriptionPlanAccessDtoFromJSON(json: any): SubscriptionPlanAccessDto {
    return SubscriptionPlanAccessDtoFromJSONTyped(json, false);
}

export function SubscriptionPlanAccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPlanAccessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedChatInterfaces': json['allowedChatInterfaces'],
        'allowedMlsProviders': json['allowedMlsProviders'],
        'allowedStates': json['allowedStates'],
    };
}

export function SubscriptionPlanAccessDtoToJSON(json: any): SubscriptionPlanAccessDto {
    return SubscriptionPlanAccessDtoToJSONTyped(json, false);
}

export function SubscriptionPlanAccessDtoToJSONTyped(value?: SubscriptionPlanAccessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedChatInterfaces': value['allowedChatInterfaces'],
        'allowedMlsProviders': value['allowedMlsProviders'],
        'allowedStates': value['allowedStates'],
    };
}

